fragment UserVideoIntegrationsFragment on User {
    id
    zoomIntegration {
        isEnabled
    }
    googleMeetIntegration {
        isEnabledMeetSync
    }
    microsoftTeamsIntegration {
        isEnabled
    }
}
